import React, { Component } from 'react';
import { MDBJumbotron, MDBContainer, MDBRow, MDBCol } from "mdbreact";

const NotFound=(props)=>{

    return (

        <MDBContainer className="mt-12 text-center">
        <MDBRow>
            <MDBCol>
 
            <img src={process.env.PUBLIC_URL + "/loading.gif"} style={{width:"300px",textAlign:"center"}} alt="loading" />
            <h3 className="h3-responsive">Please wait while we are processing your request.</h3>
       
            </MDBCol>
        </MDBRow>
        </MDBContainer>

    );


}

 
export default NotFound ;

